import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import Form from "react-bootstrap/lib/Form";
import forEach from "lodash.map";
import isEmpty from "lodash.isempty";
import cloneDeep from "lodash.clonedeep";
import SVG from "react-inlinesvg";
import { QuestionType, ProjectType, ImageMimeType } from "../../../utils/enums";
import { RouteUrls } from "../../../configs/routeUrls";
import { transformSVG } from "../../../utils/svg-extensions";

export class QuestionBudget extends Component {
  onSingleChange(questionAnswer, value) {
    if (
      questionAnswer.answerOptions[0] &&
      (questionAnswer.answerOptions[0].id > 0 ||
        questionAnswer.answerOptions[0].questionOptionId > 0)
    ) {
      let answerToUpdate = cloneDeep(questionAnswer);
      if (this.props.questionType == QuestionType.Budget) {
        answerToUpdate.answerOptions[0].openText = parseInt(value) | 0;
      }
      this.props.setFieldValue(
        `${this.props.prefixName}answers[0]`,
        answerToUpdate
      );
    } else {
      let newAnswer = [
        {
          id: 0,
          questionId: this.props.id,
          userId: this.props.loggedUserId,
          categoryId: this.props.categoryId,
          answerOptions: [
            {
              id: 0,
              comment: "",
              openText: parseInt(value) | 0,
              openDate: null,
              questionOptionId: 0,
              questionMatrixValueId: 0,
            },
          ],
        },
      ];
      this.props.setFieldValue(`${this.props.prefixName}answers`, newAnswer);
    }
  }

  render() {
    let {
      disabled,
      isAuth,
      availableVoteNotLogged,
      prefixName,
      questionAnswer = { answerOptions: [] },
      maxPoint = 0,
      errors = { answers: null },
      projectTask,
      projectType,
      onBlur,
    } = this.props;

    const task = !isEmpty(projectTask)
      ? projectTask
      : {
          id: 0,
          description: "",
          thumbMainImage: "",
          thumbMainImageContentType: ImageMimeType.SVG,
        };
    const substringDescription = task.description
      ? task.description.substring(0, 270)
      : "";

    return (
      <div className="consultation-item">
        <div className="consultation-item__header">{this.props.content}</div>
        <div
          className={`consultation-item__body consultation-item__body--center ${
            projectType === ProjectType.PublicBudget
              ? "consultation-item__body--short"
              : ""
          }`}
        >
          <div
            className={`consultation-item__desc margin-right-20 ${
              projectType === ProjectType.PublicBudget
                ? "consultation-item__desc--short"
                : ""
            }`}
          >
            <div className="consultation-description__text">
              {substringDescription}
              {
                <NavLink
                  to={`${RouteUrls.Budget.projectTasks.preview}/${task.id}`}
                  className="link"
                  target="_blank"
                  title="Szczegóły projektu"
                >
                  &nbsp;więcej
                </NavLink>
              }
            </div>
          </div>
          {(isAuth || availableVoteNotLogged) && (
            <div className="consultation-item__question">
              <Form.Row>
                <Form.Group>
                  <div className="field field--question">
                    <Form.Control
                      type="text"
                      pattern="[0-9]*"
                      max={maxPoint}
                      disabled={disabled}
                      id={`${prefixName}answers`}
                      name={`${prefixName}answers`}
                      value={
                        questionAnswer && questionAnswer.answerOptions[0]
                          ? questionAnswer.answerOptions[0].openText
                          : ""
                      }
                      onChange={(e) => {
                        this.onSingleChange(questionAnswer, e.target.value);
                      }}
                      className="field__input field__input--center"
                      onBlur={onBlur}
                      placeholder="punkty"
                      title={
                        !disabled
                          ? "Wpisz odpowiednią liczbę punków dla projektu"
                          : "Możesz oddać głos na projekt ogólnomiejski lub projekt z Twojej dzielnicy"
                      }
                      isInvalid={!!errors.answers}
                      autoComplete="off"
                    />
                  </div>
                  {typeof errors.answers === "string" && (
                    <Form.Control.Feedback
                      type="invalid"
                      style={{ display: "block", color: "red", marginTop: 10 }}
                    >
                      {errors.answers}
                    </Form.Control.Feedback>
                  )}
                  {forEach(errors.answers, (answer) => {
                    return forEach(
                      answer.answerOptions,
                      (answerOption, answerOptionIndex) => {
                        return (
                          answerOption.openText && (
                            <Form.Control.Feedback
                              key={answerOptionIndex}
                              type="invalid"
                              style={{
                                display: "block",
                                color: "red",
                                marginTop: 10,
                              }}
                            >
                              {answerOption.openText}
                            </Form.Control.Feedback>
                          )
                        );
                      }
                    );
                  })}
                </Form.Group>
              </Form.Row>
            </div>
          )}
          <div className="consultation-item__image">
            {task.thumbMainImage && (
              <figure className="thumbnail">
                {task.thumbMainImageContentType !== ImageMimeType.SVG && (
                  <div className="svg-container">
                    <img
                      className="thumbnail__content"
                      src={`data:image/jpeg;base64, ${task.thumbMainImage}`}
                      alt={`Główne zdjęcie projektu ${this.props.content}`}
                    />
                  </div>
                )}
                {task.thumbMainImageContentType === ImageMimeType.SVG && (
                  <div className="svg-container">
                    <SVG
                      src={transformSVG(
                        task.thumbMainImage,
                        `svg-question-${task.id}`,
                        `Główne zdjęcie projektu ${this.props.content}`
                      )}
                    />
                  </div>
                )}
              </figure>
            )}
          </div>
        </div>
      </div>
    );
  }
}

QuestionBudget.defaultProps = {
  prefixName: "",
  disabled: false,
  questionAnswer: undefined,
  errors: { answer: "" },
  onChange: Function.prototype,
  onBlur: Function.prototype,
};
